import { getEmailFormTemplate, getVueEmailFormTemplate } from "../../shortcodes/templates";

let emailForm = null;
const visualizeEmailFormComponents = content => {
  emailForm = content.querySelectorAll('[data-tiny-mce-component="emailform"]')[0];
  if (emailForm) {
    emailForm.innerHTML = getEmailFormTemplate();
  }
};

const serializeEmailFormComponents = content => {
  const emailWidget = content.querySelectorAll('[data-tiny-mce-component="emailform"]')[0];
  if (emailWidget) {
    const emailFormData = {
      label: content.querySelectorAll('[data-tiny-mce-component-data="label"]')[0].innerHTML,
      text: content.querySelectorAll('[data-tiny-mce-component-data="text"]')[0].innerHTML,
      buttonText: content.querySelectorAll('[data-tiny-mce-component-data="buttonText"]')[0].innerHTML,
      linkText: content.querySelectorAll('[data-tiny-mce-component-data="link"]')[0].innerHTML,
      linkHref: content.querySelectorAll('[data-tiny-mce-component-data="link"]')[0].href,
      linkTarget: content.querySelectorAll('[data-tiny-mce-component-data="link"]')[0].target,
    };
    content.querySelectorAll('[data-tiny-mce-component="emailform"]')[0].innerHTML =
      getVueEmailFormTemplate(emailFormData);
  }
};

export { visualizeEmailFormComponents, serializeEmailFormComponents };
